import { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  deleteQuestionType,
  updateQuestionProperty,
} from "../../../../../../store/steps/stepTwoSlice";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import QuestionRow from "./QuestionRow";
import AddQuestionRow from "./AddQuestionRow";
import EmptyCells from "./EmptyCells";
import { leftCellSx, rightCellSx, rowSx } from "./tableStyles";

interface TopicRowProps {
  topic: any;
  topicIndex: number;
  setNewQuestion: any;
  setModalOpen: any;
}

const TopicRow = memo(
  ({ topic, topicIndex, setNewQuestion, setModalOpen }: TopicRowProps) => {
    const dispatch = useDispatch();

    const handleChange = useCallback(
      ({ topicIndex, questionIndex, key, newValue }) => {
        dispatch(
          updateQuestionProperty({ topicIndex, questionIndex, key, newValue })
        );
      },
      [dispatch]
    );

    const handleDeleteType = useCallback(
      (topicIndex: number, questionIndex: number) => {
        dispatch(deleteQuestionType({ topicIndex, questionIndex }));
      },
      [dispatch]
    );

    return (
      <>
        <TableRow sx={rowSx}>
          <TableCell
            align="center"
            sx={{
              ...leftCellSx,
              borderLeft: 1,
              borderColor: "var(--color-table-header)",
            }}
          >
            {topic.topic} : <br /> {topic.subtopic}
          </TableCell>
          {topic?.questionTypes.length > 0 ? (
            <QuestionRow
              key={0}
              topicIndex={topicIndex}
              questionIndex={0}
              question={topic.questionTypes[0]}
              handleChange={handleChange}
              handleDeleteType={handleDeleteType}
            />
          ) : (
            <>
              <EmptyCells />
              <TableCell align="center" sx={rightCellSx}></TableCell>
            </>
          )}
        </TableRow>
        {topic.questionTypes.slice(1).map((question, questionIndex) => (
          <TableRow key={questionIndex + 1} sx={rowSx}>
            <TableCell
              sx={{
                ...leftCellSx,
                borderLeft: 1,
                borderColor: "var(--color-table-header)",
              }}
            ></TableCell>
            <QuestionRow
              topicIndex={topicIndex}
              questionIndex={questionIndex + 1}
              question={question}
              handleChange={handleChange}
              handleDeleteType={handleDeleteType}
            />
          </TableRow>
        ))}
        <AddQuestionRow
          topicIndex={topicIndex}
          setNewQuestion={setNewQuestion}
          setModalOpen={setModalOpen}
        />
      </>
    );
  }
);

export default TopicRow;
